<!-- Header -->
<h3 mat-dialog-title>
	Delete Row?
</h3>

<!-- Body -->
<mat-dialog-content>
	<span translate>
		{{message}}
	</span>
</mat-dialog-content>

<!-- Footer -->
<mat-dialog-actions style="position: sticky">

	<!-- Right Buttons -->
	<div class="footerRight">
		<tyl-button image="save.png"
			label="OK"
			(clickEvent)="OK()"></tyl-button>
		<tyl-button image="Cancel.png"
			label="Cancel"
			(clickEvent)="cancel()"></tyl-button>
	</div>
</mat-dialog-actions>